import { render, staticRenderFns } from "./MobMenu.vue?vue&type=template&id=f9edcf28&scoped=true&"
import script from "./MobMenu.vue?vue&type=script&lang=js&"
export * from "./MobMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobMenu.vue?vue&type=style&index=0&id=f9edcf28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9edcf28",
  null
  
)

export default component.exports